import React, {useEffect} from 'react'
import {useSelector, useDispatch} from 'react-redux'
import * as Member from '../../store/ducks/member.duck'
import DashboardBox from '../../components/DashboardBox'
import DashboardSection from '../../components/Cards/DashboardSection'
import {Button} from '@mui/material'

export default function BlogDashboard() {
  const blogs = useSelector((state: any) => state.member.Blogs)
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(Member.actions.fetchBlogs())
  }, [dispatch])

  interface blogitem {
    id: number
    link: string
    story: string
    title: string
    imagelink: string
    blogdate: string
  }

  return (
    <DashboardBox>
      <DashboardSection name={'Latest Blogs'}>
        <div className='grid grid-cols-1 md:grid-cols-2 gap-[30px]'>
          {blogs &&
            blogs.map((dataEl: blogitem, i: any) => {
              return <BlogCard key={i} {...dataEl} />
            })}
        </div>
      </DashboardSection>
    </DashboardBox>
  )
}

interface BlogCardProps {
  id: number
  link: string
  story: string
  title: string
  imagelink: string
  blogdate: string
}

function BlogCard({imagelink, title, blogdate, link, story}: BlogCardProps) {
  function handleClick() {}
  return (
    <div className='blog-card'>
      <a href={link}>
        <img src={imagelink} alt={title} className='w-full' />
        <div className='py-8 px-4 gap-3'>
          <h3>{title}</h3>
          <p className='publication-text'>{blogdate}</p>
          <p className='news-text line-clamp-3 mb-12'>{story}</p>
          <Button variant='contained' onClick={handleClick}>
            <p className='mb-0 p-1.5'>{'Read more'}</p>
          </Button>
        </div>
      </a>
    </div>
  )
}
